import { QRCodeSVG } from "qrcode.react";

export default function RegistrationCrm() {
    const qrUrl = "https://jinraitech.com/crm/registration";

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-white p-6 mt-1">
            {/* Card */}
            <div className="relative bg-gradient-to-tr from-[#0a3021] to-[#47c592]  rounded-2xl shadow-lg text-center w-full max-w-sm pt-16 pb-8 px-6">

                {/* Heading */}
                <h2 className="text-[20px] font-bold text-white">Create CRM Account</h2>
                <p className="text-sm text-white/80 mb-6">Scan this QR to create your account</p>

                {/* QR Code box */}
                <div className="bg-white rounded-xl p-4 shadow-md inline-block">
                    <QRCodeSVG value={qrUrl} size={200} />
                </div>
            </div>

            {/* Bottom Button */}
            <button className="mt-4 w-full max-w-sm py-3 bg-[#0a3021] text-white rounded-xl shadow-md hover:opacity-90 transition font-bold">
                Scan Code
            </button>
        </div>
    );
}
